import React from "react";
import Row from "../../common/layout/row";
import Select from "../../common/form/select";
import { useEffect } from "react";

export function Filtros(props) {
    useEffect(() => {
        if ([1, 2].includes(props.usuarioLogado.id)) {
            props.setFiltro({
                ...props.filtro,
                id_empresa: props.filtro.id_empresa || 1 //caso seja um dos usuários master, se o filtro tiver vazio, define a eficience como padrão
            });
        }
    }, []);

    return (
        <Row>
            {!props.usuarioLogado.id_empresa ? (
                <Select
                    name="id_empresa"
                    label="Empresa"
                    options={props.listaEmpresa}
                    placeholder="Selecione a Empresa"
                    cols="12 4 4 4"
                    value={props.filtro.id_empresa}
                    onChange={(value) => {
                        props.setFiltro({
                            ...props.filtro,
                            id_empresa: value,
                            id_cliente: null,
                        });
                    }}
                />
            ) : null}

            {!props.usuarioLogado.acesso_cliente ? (
                <Select
                    name="id_cliente"
                    options={props.listaCliente}
                    label="Cliente"
                    cols={!props.usuarioLogado.id_empresa ? "12 4 4 4" : "12 8 8 8 "}
                    placeholder="Selecione o Cliente"
                    value={props.filtro.id_cliente}
                    onChange={(value) => {
                        const cliente = props.listaCliente.find((cli) => cli.id == value);
                        const id_empresa = cliente ? cliente.id_empresa : null;
                        props.setFiltro({
                            ...props.filtro,
                            id_cliente: value,
                            id_empresa,
                        });
                    }}
                />
            ) : null}

            <Select
                name="mes_base"
                options={props.listaMesBase}
                label="Mês Base"
                cols="12 4 4 4"
                placeholder="Selecione o Mês Base"
                value={props.filtro.mes_base}
                isClearable={false}
                onChange={(value) => {
                    props.setFiltro({
                        ...props.filtro,
                        mes_base: value,
                    });
                }}
            />
        </Row>
    );
}
